/* eslint-disable import/no-anonymous-default-export */
import request from '@hho-middle/network'

export default {
  getUserInfo: () => request('/user/getUserInfo').get(),
  setUserAuthority: (data) => request('/user/setUserAuthority').post({ data }),
  logout: () => request('/jwt/jsonInBlacklist').post(),
}